var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2",
    clipPath: "url(#clip0_5832_32484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 0C0.780723 0 0.333008 0.447715 0.333008 1V27C0.333008 27.5523 0.780724 28 1.33301 28H22.6663C23.2186 28 23.6663 27.5523 23.6663 27V4.66634L19 0H1.33301Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6663 4.66634V4.66667H19V0L23.6663 4.66634Z",
    fill: "#B1B1B1"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line 271",
    opacity: 0.4,
    x1: 3,
    y1: 8.5,
    x2: 21,
    y2: 8.5,
    stroke: "#696969"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 272",
    opacity: 0.4,
    x1: 3,
    y1: 12.5,
    x2: 21,
    y2: 12.5,
    stroke: "#696969"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 273",
    opacity: 0.4,
    x1: 3,
    y1: 16.5,
    x2: 21,
    y2: 16.5,
    stroke: "#696969"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9415",
    x: 3,
    y: 17,
    width: 18,
    height: 7,
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5832_32484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3333,
    height: 28,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.fa6e54dac51125026be92d586477ebf8.svg";
export { ForwardRef as ReactComponent };